<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading full-character-formatting element-with-heading-image" id="unnumbered-1">
<div class="heading heading-with-title heading-with-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-mixed">Blurb</h1>
</div>
</div>
<div class="heading-image-block heading-image-aspect-square heading-image-block-after-title-and-subtitle">
<div class="heading-image-size-container heading-image-width-250">
<img alt="" class="heading-image-image" src="images/image-5_c2tldgnoihr5cgv3cml0zxi.jpg"/>
</div>
</div>
</div>
</div>
<div class="text" id="unnumbered-1-text">
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">The dragon's blood that saved her had one little unforeseen consequence—it turned her into a <i>draugr</i>, a vampire.</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">Leslie always wanted to be number one at something, and the Readers’ Cruise was her chance to make a big splash into the romance writing world.</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">Until she fell into the Atlantic Ocean.</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">With her life hanging in the balance, it would take a miracle to save her from death’s icy grip.</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">That miracle is Alistair McLeod, a handsome dragon-shifter, who shouldn’t exist. But now she's counted among the living dead.</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">Marked and hungry, Leslie awakens as an unwilling vampire and a new member to the Order—the supernatural security force for a secret society of the shadow world.</p>
<p class="alignment-block-content alignment-block-content-left">Danger, intrigue, and murder are her new reality. And when women end up drained, their bodies mangled by a vampire’s bite, Leslie is the Order’s top suspect.</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">These murders threaten everything the Order stands for, which means the Order now threatens her.</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">To save her life, Leslie must now embrace her magical destiny—or fall victim to a deadly menace.</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">Discover what’s at stake in Tina Glasneck’s new take on vampire lore with Once Bitten!</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// blurb.vue?db03f956